import { mailsSubMenu as communication } from "Pages/Project/Communication/Stores/mailsSubMenu";
import { subMenuConfig as qa } from "Pages/Project/QA/Components/subMenuConfig";
import { subMenuConfig as workflow } from "Pages/Project/Workflow/subMenuConfig";
import { subMenuConfig as reports } from "Pages/Project/Reports/subMenuConfig";
import { subMenuConfig as tasks } from "Pages/Project/Tasks/subMenuConfig";
import { subMenuConfig as groups } from "Pages/Project/Groups/subMenuConfig";
import { subMenuConfig as contacts } from "Pages/Project/Contacts/subMenuConfig";
import { subMenuConfig as docs } from "Pages/Project/Documents/subMenuConfig";
import { subMenuConfig as pm } from "Pages/Project/ProjectManagement/subMenuConfig";
import { subMenuConfig as ov } from "Pages/Project/ObjectsAndData/subMenuConfig";
import { subMenuConfig as bim } from "Pages/Project/BIM/subMenuConfig";
import project from "Pages/Project/Overview/subMenuConfig";
import { subMenuConfig as tender } from "Pages/Project/Tender/subMenuConfig";
import { subMenuConfig as defectManagement } from "Pages/Project/OxIntegration/subMenuConfig";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { observer } from "mobx-react";
import { I18N_NS } from "Config/i18n";
import React from "react";
import { useTranslation } from "react-i18next";
import { CoreStore } from "Stores/RESTStore/CoreStore";

export interface SubmenuItem {
  label: string | JSX.Element;
  link: string;
  icon?: IconName | React.ReactNode;
  subModule?: string;
  message?: string | JSX.Element;
  isActive?: (x: string) => boolean;
}

export type SubMenusObjectConfig = Partial<Record<PROJECT_MODULES, { config: SubmenuItem[] }>>;
/**
 * Allows to add custom submenus with links to any module in sidebar.
 * Submenu link should be used to navigate to the pages in module
 */
export const subMenus: SubMenusObjectConfig = {
  PROJECT_OVERVIEW: project,
  MAIL: communication,
  QA: qa,
  WORKFLOW: workflow,
  REPORTS: reports,
  TASKS: tasks,
  GROUPS: groups,
  CONTACTS: contacts,
  TENDER_MODERN: tender,
  DOCUMENTS_AND_PLANS: docs,
  PROJECT_MANAGMENT: pm,
  VALUE_TABLE: ov,
  OX_MODULES: defectManagement,
  BIM: bim,
};

interface MenuItemWithBadgeProps {
  prop?: keyof API_QACounts;
  label: string;
  store?: CoreStore;
}

export const MenuItemWithBadge = observer(({ store = {} as CoreStore, prop, label }: MenuItemWithBadgeProps) => {
  const { t } = useTranslation(I18N_NS.PROJECT);
  return (
    <div className="menu-with-badge">
      {t(label)} {store[prop] ? <span>{store[prop]}</span> : ""}
    </div>
  );
});
